module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery"
  }, [_c('gallery', {
    attrs: {
      "imageList": _vm.imageList,
      "selectedImage": _vm.selected
    },
    on: {
      "select-image": _vm.selectImage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-333d8af6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@oliverstore/core-rendering-engine/src/views/rendering_block/GalleryBlock.vue
// module id = 344
// module chunks = 1